<template>
    <label :for="key" class="tag__cloud--wrapper">
        <div v-if="staticEntries && entries && Object.keys(entries).length > 0" class="static--wrapper">
            <div @click="toggleList" class="static--bullet">
                <span></span>
                <span></span>
            </div>
            <div v-if="staticListVisible" class="static--list">
                <span @click="addEntry(entry)" :key="entry.id" v-for="entry in entries">{{entry.value}}</span>
            </div>
        </div>
        <span class="tag__cloud" v-for="text in keywords" :key="text">
            <template v-if="staticEntries">
                <span>{{text.value}}</span>
                <div @click="removeEntry(text)" class="bullet">
                    <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100">
                        <path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:18.05195999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                        <path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:17.80202103;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                    </svg>
                </div>
            </template>
            <template v-else>
                <span @click="editEntry(text)">{{text}}</span>
                <div @click="removeEntry(text)" class="bullet">
                    <svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 100 100">
                        <path d="M 6.3895625,6.4195626 C 93.580437,93.610437 93.580437,93.610437 93.580437,93.610437" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:18.05195999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                        <path d="M 6.3894001,93.6106 C 93.830213,6.4194003 93.830213,6.4194003 93.830213,6.4194003" style="fill:none;fill-rule:evenodd;stroke:#ffffff;stroke-width:17.80202103;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"/>
                    </svg>
                </div>
            </template>
        </span>
        <input v-if="!staticEntries" autocomplete="off" :id="key" :name="key" v-model="keyword" v-on:keyup.enter="onEnter" type="text">
    </label>
</template>

<script>
export default {
    data() {
        return {
            keyword: null,
            staticListVisible: false,
        }
    },
    emits: ['remove-entry', 'add-entry'],
    props: {
        keywords: {
            type: Array,
            required: true,
        },
        key: {
            type: String,
            required: true,
        },
        staticEntries: {
            type: Boolean,
            required: false,
        },
        entries: {
            type: Object,
            required: false,
        }
    },
    methods: {
        toggleList() {
            this.staticListVisible = !this.staticListVisible;
        },

        removeEntry(text) {
            this.$emit('remove-entry', text);
        },
        onEnter() {
            if(this.keyword.length > 0) {
                this.keyword = this.keyword + ",";
            }
        },
        
        editEntry(text) {
            this.$emit('remove-entry', text);
            this.keyword = text;
        },

        addEntry(entry) {
            console.log(entry);
            this.$emit('add-entry', entry);
        },
        findAncestor (el, cls) {
            if(el.classList.contains(cls)) {
                return el;
            }
            while ((el = el.parentElement) && !el.classList.contains(cls));
            return el;
        }
    },
    mounted() {
        document.addEventListener("mouseup", e => {
            if(this.staticListVisible) {
                if(!this.findAncestor(e.target, "static--list")) {
                    this.staticListVisible = false;

                }
            }
        })
    },
    watch: {
        keyword() {
            if(this.keyword.length > 1) {
                var tagTextArray = this.keyword.split(',');
                if(tagTextArray.length > 1) {
                    var keyword = tagTextArray[0];
                    if(keyword.length > 0) {
                        this.$emit('add-entry', keyword);
                        this.keyword = this.keyword.split(',')[1];
                    }
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .tag__cloud--wrapper{
        background-color: #FFFFFF;
        padding: 15px;
        border: 1px solid #BBBBBB;
        min-height: 90px;
        display: block;
        width: 100%;
        box-sizing: border-box;
    }
    .tag__cloud{
        margin-bottom: 10px;
        -moz-user-select: none;
    }
    input{
        padding: 0;
        line-height: 33px;
        outline: none !important;
        vertical-align: top;
        border: none;
        background: transparent;
        width: auto;
        display: inline-block;
        min-width: auto;
        font-size: 16px;
    }
    .static--wrapper{
        position: relative;
        display: inline-block;
        vertical-align: top;

        .static--bullet {
            border-radius: 50%;
            border: 2px solid rgba(0, 0, 0, 0.5);
            width: 24px;
            height: 24px;
            position: relative;
            cursor: pointer;
            margin-right: 10px;

            span{
                width: 2px;
                background-color: rgba(0, 0, 0, 0.5);
                height: 16px;
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -8px;
                margin-left: -1px;

                &:last-child{
                    transform: rotate(90deg);
                }
            }

            
        }
        .static--list{
            box-sizing: border-box;
            display: block;
            background-color: #F5F5F5;
            border: 1px solid #CCCCCC;
            border-radius: 8px;
            position: absolute;
            left: 40px;
            top: 0;
            padding: 10px 20px;
            z-index: 9;
            width: 400px;

            span{
                color: #575C61;
                background-color: #FFFFFF;
                border: 1px solid #E6E6E6;
                border-radius: 20px;
                padding: 5px 10px;
                margin-right: 10px;
                margin-bottom: 10px;
                position: relative;
                display: inline-block;
                cursor: pointer;
            }
        }
    }
</style>